import actions from '../../store/actions'
import { useState } from 'react'
import { mutations } from '../../resources'
import { generateError } from '../../helpers/errors'
import { SpecialClosing, SpecialClosingRequest } from '../../resources/establishment/types'
import { useDispatch } from '../redux'
import { AxiosResponse } from 'axios'

export const useCreateSpecialClosing = () => {
    const dispatch = useDispatch()
    const [inProgress, setInProgress] = useState(false)

    const createSpecialClosing = (payload: SpecialClosingRequest): Promise<AxiosResponse<SpecialClosing>> => {
        setInProgress(true)
        return mutations
            .createSpecialClosing(payload)
            .then((response) => {
                setInProgress(false)
                dispatch(actions.addSpecialClosing(response.data))
                return response
            })
            .catch((error) => {
                setInProgress(false)
                throw generateError(error)
            })
    }

    return {
        createSpecialClosing,
        inProgress,
    }
}
